/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAlertDecisionRule,
    InternalApiAlertDecisionRuleFromJSON,
    InternalApiAlertDecisionRuleToJSON,
    InternalApiCreateAlertDecisionRulesCommand,
    InternalApiCreateAlertDecisionRulesCommandFromJSON,
    InternalApiCreateAlertDecisionRulesCommandToJSON,
} from '../models';

export interface UpdateDecisionRulesRequest {
    internalApiCreateAlertDecisionRulesCommand: InternalApiCreateAlertDecisionRulesCommand;
}

/**
 * 
 */
export class DecisionRulesApi extends runtime.BaseAPI {

    /**
     * Get all decision rules for organisation
     */
    async findDecisionRulesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiAlertDecisionRule>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/decision-rules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiAlertDecisionRuleFromJSON));
    }

    /**
     * Get all decision rules for organisation
     */
    async findDecisionRules(initOverrides?: RequestInit): Promise<Array<InternalApiAlertDecisionRule>> {
        const response = await this.findDecisionRulesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update decision rule block based on entity type and org id
     */
    async updateDecisionRulesRaw(requestParameters: UpdateDecisionRulesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiAlertDecisionRule>>> {
        if (requestParameters.internalApiCreateAlertDecisionRulesCommand === null || requestParameters.internalApiCreateAlertDecisionRulesCommand === undefined) {
            throw new runtime.RequiredError('internalApiCreateAlertDecisionRulesCommand','Required parameter requestParameters.internalApiCreateAlertDecisionRulesCommand was null or undefined when calling updateDecisionRules.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/decision-rules`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCreateAlertDecisionRulesCommandToJSON(requestParameters.internalApiCreateAlertDecisionRulesCommand),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiAlertDecisionRuleFromJSON));
    }

    /**
     * Update decision rule block based on entity type and org id
     */
    async updateDecisionRules(requestParameters: UpdateDecisionRulesRequest, initOverrides?: RequestInit): Promise<Array<InternalApiAlertDecisionRule>> {
        const response = await this.updateDecisionRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
